import React from 'react'
import './DescriptionBox.css'
const DescriptionBox = () => {
  return (
    <div className="descriptionbox">
      <div className="descriptionbox-navigator">
        <div className="descriptionbox-nav-box">Description</div>
        <div className="descriptionbox-nav-box fade">Reviews (122)</div>
      </div>
      <div className="descriptionbox-description">
        
        <p>An e commerce website here is developed with an iidea of understanding the multi user serving concept and also for managing transactions and many more features</p>
        <p>
        website here is developed with an iidea of understanding the multi user serving c
        </p>
      </div>
    </div>
  )
}

export default DescriptionBox
